import React from "react";
import { Tag } from "@blueprintjs/core";
import { VISIBLE_LANGUAGES, GA_LANGUAGE_IDS } from "../../../lang";
import { Link } from "react-router-dom";
import styled from "styled-components";

const LanguageTag = styled(Tag)`
  background: #2a1c51;
  font-size: var(--global-font-size-s);
  line-height: var(--global-font-size-m);
  margin-bottom: 12px;
  margin-right: 12px;
  padding: 4px 6px;
  border: 1px solid var(--button-indigo);
  border-radius: 4px;
  :hover {
    background: var(--button-indigo-hover);
    color: var(--global-off-white);
    text-decoration: none;
  }
  :active {
    background: var(--button-indigo-active);
    text-decoration: none;
  }
`;

const TagButton = styled(LanguageTag)`
  background: var(--button-indigo);
`;

const LanguageSupport: React.FC = () => {
  const ga = GA_LANGUAGE_IDS.map((id) => [
    VISIBLE_LANGUAGES[id].name,
    VISIBLE_LANGUAGES[id].name,
  ]);
  const languages = [
    ...ga,
    ["JSX", "JavaScript"],
    ["TSX", "TypeScript"],
    ["Generic (YAML, ERB, Jinja, etc)", "Generic"],
  ];
  return (
    <div style={{ paddingTop: "20px" }}>
      <div
        style={{ fontSize: "24px", lineHeight: "36px", marginBottom: "20px" }}
      >
        Language support
      </div>
      <div>
        {languages.map(([name, filter]) => (
          <Link
            to={`/r/?lang=${encodeURIComponent(filter)}`}
            key={name}
            style={{ textDecoration: "none" }}
          >
            <LanguageTag>{name}</LanguageTag>
          </Link>
        ))}
        <a href="/docs/status/" style={{ textDecoration: "none" }}>
          <TagButton>+ More languages</TagButton>
        </a>
      </div>
    </div>
  );
};

export default LanguageSupport;
